<template>
    <div
        id="submit"
        @click="
            loadDetail();
            showDetail = !showDetail;
        "
    >
        <div class="row align-space-between">
            <div class="row align-center" style="gap: 12px">
                <p style="font-size: 28px; font-weight: bold">{{ title }}</p>
                <div
                    v-show="status != ''"
                    class="align-center"
                    style="
                        height: 28px;
                        border: 1px solid #cecece;
                        padding: 2px 16px;
                        border-radius: 20px;
                    "
                >
                    <p style="font-size: 12px">
                        {{ status }}
                    </p>
                </div>
            </div>

            <div class="row" style="gap: 12px">
                <text-button
                    :textSize="14"
                    :buttonName="'취소'"
                    :buttonStyle="{
                        border: '1px solid #CECECE',
                        padding: '4px 16px',
                        background: 'white',
                    }"
                    :textColor="status != '취소' ? 'red' : 'gray'"
                    :style="{
                        cursor: status == '취소' ? 'default' : 'pointer',
                    }"
                    @click="openPinModal"
                ></text-button>
            </div>
        </div>
        <div class="row align-space-between" style="margin-top: 16px">
            <p style="font-size: 20px; font-weight: normal; color: #5f5f5f">
                {{ category }}
            </p>
            <p style="font-size: 20px; font-weight: normal; color: #5f5f5f">
                {{ date }}
            </p>
        </div>
        <div v-show="showDetail" class="detail">
            <div class="row" style="gap: 16px">
                <p style="font-size: 16px; font-weight: bold">교육장소</p>
                <p style="font-size: 16px; font-weight: bold">:</p>
                <p style="font-size: 16px">
                    {{ lecture != null ? lecture.location : "" }}
                </p>
            </div>
            <div class="row" style="gap: 16px">
                <p style="font-size: 16px; font-weight: bold">교육시간</p>
                <p style="font-size: 16px; font-weight: bold">:</p>
                <p style="font-size: 16px">
                    {{ lecture != null ? lecture.start_time : "" }} ~
                    {{ lecture != null ? lecture.end_time : "" }}
                </p>
            </div>
            <div class="row" style="gap: 16px">
                <p style="font-size: 16px; font-weight: bold; width: auto">
                    교육내용
                </p>
                <p style="font-size: 16px; font-weight: bold">:</p>
                <p style="font-size: 16px; width: 90%">
                    {{ lecture != null ? lecture.detail : "" }}
                </p>
            </div>
        </div>

        <PinModal
            ref="pinModal"
            :target="1"
            :targetId="applyId"
            @pinVerified="handlePinVerified"
        />
    </div>
</template>

<script>
import { defineComponent, ref, onMounted, onUpdated } from "vue";
import { useStore } from "vuex";
import TextButton from "./TextButton.vue";
import PinModal from "@/components/PinModal.vue";

export default defineComponent({
    props: {
        title: {
            type: String,
            default: "",
        },
        category: {
            type: String,
            default: "",
        },
        date: {
            type: String,
            default: "",
        },
        status: {
            type: String,
            default: "",
        },
        applyId: {
            type: Number,
            default: 0,
        },
        lectureId: {
            type: Number,
            default: 0,
        },
        phone_number: {
            type: String,
            defalut: "",
        },
        userId: {
            type: Number,
            default: null
        },

        onClick: Function,
    },
    components: {
        TextButton,PinModal
    },
    setup(props) {
        const isCheck = ref(false);
        const store = useStore();
        const lecture = ref(null);
        const isLoad = ref(false);

        onMounted(() => {
            isCheck.value = props.checked;
        });

        onUpdated(() => {
            isCheck.value = props.checked;
        });


        const showDetail = ref(false);

        const loadDetail = async () => {
            if (isLoad.value) {
                return;
            }
            lecture.value = await store.dispatch("getLecture", props.lectureId);
            lecture.value.detail = lecture.value.detail.replace(/\n/g, "<br>");
            isLoad.value = true;
        }; 
        const pinModal = ref(null);
        
        const openPinModal = () => {
            pinModal.value.openModal();
        };

        const handlePinVerified = (isAuth) => {
            if (isAuth) {
                
                    store.dispatch("deleteApplyLecture", {
                        id: props.applyId,
                        param: {
                            userId: props.userId,
                            phone_number: props.phone_number,
                            page: 0,
                            take: 10,
                        },
                    });
                    alert("삭제되었습니다");
                    showDetail.value = false;
                    isLoad.value = false;
            }
        };

        return {
            isCheck,
            showDetail,
            loadDetail,
            lecture,
            handlePinVerified,
            openPinModal,
            pinModal
        };
    },
});
</script>

<style scoped>
button {
    padding: 8px 16px;
    border: 0.5px solid black;
    border-radius: 20px;
}

#submit {
    width: 100%;
    padding: 16px 24px;
    border-bottom: 1px solid #b3b3b3;
    /* cursor: pointer; */
}

.detail {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
}
</style>
